import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { UserListUploadInitialState, UploadUserListData } from './user-list-upload.actions';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { UserListUploadService } from './user-list-upload.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface UserListUploadStateModel {
  loaded: boolean;
  file: string | ArrayBuffer;
}

const initialState: UserListUploadStateModel = {
  loaded: false,
  file: null,
};

@State<UserListUploadStateModel>({
  name: 'userListUpload',
  defaults: initialState,
})
@Injectable()
export class UserListUploadState {
  constructor(private userListService: UserListUploadService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: UserListUploadStateModel): UserListUploadStateModel {
    return state;
  }
  @Selector()
  static getLoaded(state: UserListUploadStateModel): boolean {
    return state.loaded;
  }

  @Action(UserListUploadInitialState)
  setInitialState(ctx: StateContext<UserListUploadStateModel>): void {
    ctx.setState(initialState);
  }

  @Action(UploadUserListData)
  uploadFile(
    ctx: StateContext<UserListUploadStateModel>,
    { payload }: UploadUserListData,
  ): Observable<string | MatSnackBarRef<SimpleSnackBar> | Observable<MatSnackBarRef<SimpleSnackBar>>> {
    return this.userListService
      .uploadDocument(payload.language, payload.userTimezone, payload.userCountry, payload.file)
      .pipe(
        take(1),
        map((file: string) => {
          ctx.patchState({ loaded: true, file });
          return of(this.notificationService.success('administration.addressManagement.successUpload'));
        }),
        catchError(({ error }: HttpErrorResponse) => {
          ctx.patchState({ loaded: false, file: null });
          return of(this.notificationService.error(error.message));
        }),
      );
  }
}
